export class ClassificationDoesNotExists extends Error {
  constructor(message) {
    super(message);
    this.message = message || 'Classification does not exists';
  }
}


export class ClassificationsEmpty extends Error {
  constructor(message) {
    super(message);
    this.message = message || 'Classifications array is empty';
  }
}


export class SellerDoesNotExists extends Error {
  constructor(message) {
    super(message);
    this.message = message || 'Seller does not exists';
  }
}


export class SellersEmpty extends Error {
  constructor(message) {
    super(message);
    this.message = message || 'Sellers array is empty';
  }
}


export class DateNotAllowed extends Error {
  constructor(message) {
    super(message);
    this.message = message || 'Date not allowed';
  }
}


export class DatesEmpty extends Error {
  constructor(message) {
    super(message);
    this.message = message || 'Dates array is empty';
  }
}


export class NoCurrentClassification extends Error {
  constructor(message) {
    super(message);
    this.message = message || 'No current classification';
  }
}


export class NoCurrentCategory extends Error {
  constructor(message) {
    super(message);
    this.message = message || 'No current category';
  }
}


export class NoMoreCategoriesToLoad extends Error {
  constructor(message) {
    super(message);
    this.message = message || 'No more categories to load';
  }
}


export class NoMoreItemsToLoad extends Error {
  constructor(message) {
    super(message);
    this.message = message || 'No more items to load';
  }
}


export class ProductsEmpty extends Error {
  constructor(message) {
    super(message);
    this.message = message || 'Products array is empty';
  }
}


export class ThresholdNotAllowed extends Error {
  constructor(message) {
    super(message);
    this.message = message || 'Threshold not allowed';
  }
}
